import {
    InputPrefix,
    InputSuffix,
    TextBox,
} from "@progress/kendo-react-inputs";
import { MagnifyingGlass } from 'phosphor-react-sc';
import { Trash } from '@phosphor-icons/react';

export default function SearchTextbox({
    value = "",
    onChange,
    placeholder = "",
    disabled = false,
    autoFocus = false
    }) {

    return (
        <TextBox
            prefix={() => (
                <>
                    <InputPrefix>
                        &nbsp;<MagnifyingGlass weight="duotone" size={20} />
                    </InputPrefix>
                </>
            )}
            suffix={() => (
                <>
                    <InputSuffix>
                        <Trash size={20} onClick={onClear} weight="duotone" />&nbsp;
                    </InputSuffix>
                </>
            )}
            disabled={disabled}
            placeholder={placeholder}
            value={value}
            onChange={onTextChange}
            autoFocus={autoFocus}
            className="font-size-lg"
        />
    );

    function onTextChange(e) {
        if (disabled === true || onChange === undefined) return;

        onChange(e);
    }

    function onClear() {
        onChange({ value: "" });
    }
}

